import React from "react";
import "./Paginado.css"


export default function Paginado ({videoGamesPerPage, allVideogames,paginado, setcurrentPage}) {
    const pageNumbers = [];

    for (let i = 1; i <= Math.ceil(allVideogames/videoGamesPerPage); i++){
        pageNumbers.push(i);
    }
    function handleInicio(){
        setcurrentPage(pageNumbers[0])
    }
    function handleFinal(){
        setcurrentPage(pageNumbers.length)
    }
    return(
        <nav >
            <ul className="containerPaginado">
               
            <button className="buttonPaginadoInicio" onClick={(ta)=>handleInicio(ta)}>Inicio</button>
                {pageNumbers &&
                pageNumbers.map((n) => {
                return (
                    <div key={n} className="containerButton">
                    <button className="buttonPaginado"  onClick={() => paginado(n)}>
                    {n}
                    </button>
                     </div>
                );
                })}
            <button className="buttonPaginadoFinal" onClick={(ta)=>handleFinal(ta)}>Final</button>
            
            </ul>
           
        </nav>
    )

}